import styled from "styled-components";

export const Flex = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`;
